import { CSSProperties, FC } from "react";
import styles from './Heading.module.css';

interface IHeadingProps {
    children: string;
    style?: CSSProperties;
    className?: string;
}

export const Heading: FC<IHeadingProps> = ({children, style, className}) => {
    return <h1 style={style} className={`${styles['Heading']} ${className ?? ''}`}>
        {children}
    </h1>
}